module.exports = __webpack_public_path__ + "static/media/rosa.2ec9d01f.jpeg";